<template>
  <div>
    <div class="content">
      <div class="logo"></div>

      <!-- 手机号输入 -->
      <div class="input-wrap" :class='borderFlag ? "have-border" : ""'>
        <label for="phone" class="title">手机号码</label>
        <cube-input
            v-model="info.account"
            placeholder="请输入您的手机号"
            type="tel"
            id="phone"
            @input="onMobileInput"
            :maxlength="maxTel"
        />
      </div>

      <!-- 图形验证码区域（新增） -->
      <div class="captcha-wrap">
        <div class="input-wrap captcha-input-wrap">
          <label class="title">图形验证码</label>
          <cube-input
              v-model="captchaInput"
              placeholder="请输入图形验证码"
              :maxlength="6"
              @input="onCaptchaInput"
          />
        </div>
        <div class="captcha-image">
          <img :src="captchaImgUrl" alt="验证码" @click="refreshCaptcha" v-if="captchaImgUrl" />
          <span v-else class="captcha-loading">加载中...</span>
<!--          <i class="refresh-icon" @click="refreshCaptcha">⟳</i>-->
        </div>
      </div>

      <!-- 短信验证码区域 -->
      <div class="identify_no_wrap idCard">
        <div class="input-wrap" :class='borderMark ? "have-border" : ""'>
          <label for="identify-no" class="title">验证码</label>
          <cube-input
              v-model="info.code"
              placeholder="请输入验证码"
              type="tel"
              id="identify-no"
              @input="onCodeInput"
              :maxlength="maxCode"
          />
        </div>
        <div
            :class="{
            get_code_btn: true,
            can_get_code: canGetCode && !!captchaInput && !!captchaKey,
            cannot_get_code: !(canGetCode && !!captchaInput && !!captchaKey)
          }"
            @click="getCode"
            v-if="!isGettingCode"
        >
          {{ text }}
        </div>
        <div
            :class="{ get_code_btn: true, cannot_get_code: !canGetCode }"
            v-if="isGettingCode"
        >
          重新发送{{ countDownSecond }}s
        </div>
      </div>

      <div
          :class="{ loginBtn: true, canLogin: !isCodeEmpty && canGetCode }"
          @click="onLoginClick"
      >
        登录
      </div>
      <div class="xieYi">
        <span class="agree">登录代表您已经同意</span>
        <span class="agreeText" @click="navigateTo('./agreement')">《登录注册协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import { getIdentifyCode, codeLogin, getCommunal, getCaptchaImage } from '@/api/common'
import utils from '@/assets/jslibs/utils'
import { UpMinOpenid } from '@/api/common'
import wx from 'weixin-js-sdk'
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  data() {
    return {
      info: {
        account: '',
        code: ''
      },
      maxTel: 11,
      maxCode: 4,
      countDownSecond: '',
      text: '获取验证码',
      isGettingCode: false,
      canGetCode: false,
      isCodeEmpty: true,
      timer: null,
      borderFlag: false,
      borderMark: false,
      // 图形验证码相关
      captchaInput: '',
      captchaKey: '',
      captchaImgUrl: ''
    }
  },

  created() {
    this.getCommunal()
    sessionStorage.removeItem('peg')
    sessionStorage.removeItem('stamp')
    sessionStorage.removeItem('mark')
    sessionStorage.removeItem('sign')
    utils.setCookie('X-Access-Token', '', -1)
    utils.removeSession('X-Access-Token')
    localStorage.removeItem('min_openid')
    sessionStorage.removeItem('roleName')
  },

  mounted() {
    document.title = '登录'
    this.refreshCaptcha() // 加载图形验证码
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },

  methods: {
    ...mapMutations(['update_expiry_time']),

    // 手机号输入处理
    onMobileInput() {
      if (this.info.account.length >= 2) {
        this.borderFlag = true
        this.borderMark = false
      } else {
        this.borderFlag = false
      }
      if (this.info.account.length >= 11) {
        this.canGetCode = true
      } else {
        this.canGetCode = false
      }
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    onCodeInput() {
      this.isCodeEmpty = this.info.code === ''
    },

    // 图形验证码输入处理（可触发按钮状态更新）
    onCaptchaInput() {
      // 无需额外逻辑，但可触发按钮可点状态更新（由计算属性自动处理）
    },

    /**
     * 获取图形验证码
     */
    async refreshCaptcha() {
      try {
        const res = await getCaptchaImage()
        if (res.status === 200 && res.data) {
          this.captchaImgUrl = res.data.imgUrl
          this.captchaKey = res.data.key
          this.captchaInput = '' // 刷新后清空输入
        } else {
          console.error('获取图形验证码失败')
        }
      } catch (error) {
        console.error('获取图形验证码异常', error)
      }
    },

    /**
     * 获取短信验证码（增加图形验证码校验）
     */
    async getCode() {
      // 防止重复点击（倒计时中不可点击）
      if (this.isGettingCode) return

      const { account } = this.info
      if (!account) {
        window.toast('请输入您的手机号', 'txt')
        return
      }
      if (!/^1[0123456789]\d{9}$/.test(account)) {
        window.toast('手机号码有误', 'txt')
        return
      }

      // 校验图形验证码
      if (!this.captchaInput) {
        window.toast('请输入图形验证码', 'txt')
        return
      }
      if (!this.captchaKey) {
        window.toast('图形验证码无效，请刷新重试', 'txt')
        await this.refreshCaptcha()
        return
      }

      const obj = {
        type: '1',
        mobile: account,
        captchaCode: this.captchaInput,
        captchaKey: this.captchaKey
      }

      try {
        const { status, message } = await getIdentifyCode(obj)
        if (status !== 200) {
          window.toast(message || '获取验证码失败，请重试', 'txt')
          await this.refreshCaptcha() // 失败刷新验证码
          return
        }

        // 成功：开始倒计时，刷新图形验证码（防止复用）
        this.borderMark = true
        this.borderFlag = false
        this.countDown()
        await this.refreshCaptcha()
      } catch (error) {
        console.error('获取验证码异常', error)
        window.toast('获取验证码失败，请重试', 'txt')
        await this.refreshCaptcha()
      }
    },

    /**
     * 60秒倒计时
     */
    countDown() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.countDownSecond = TIME_COUNT
        this.isGettingCode = true
        this.timer = setInterval(() => {
          if (this.countDownSecond > 0 && this.countDownSecond <= TIME_COUNT) {
            this.countDownSecond--
          } else {
            this.text = '重新获取'
            this.isGettingCode = false
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },

    /**
     * 登录（不变）
     */
    async onLoginClick() {
      const { account } = this.info
      if (this.isCodeEmpty) return
      if (!this.canGetCode) return
      if (!/^1[0123456789]\d{9}$/.test(account)) {
        window.toast('手机号码有误', 'txt')
      } else {
        const { data, status } = await codeLogin(this.info)
        if (status !== 200) return
        utils.setCookie('X-Access-Token', data.user_access_token.token, 7)
        this.update_expiry_time(data.user_access_token.expiry_time)
        this.$router.push('./index')
        sessionStorage.setItem('roleName', 'customer')
      }
    },

    async getCommunal() {
      const { data, status } = await getCommunal()
      if (status !== 200) return
      this.$store.commit('setImgUrl', data.BucketDomain)
      sessionStorage.setItem('imgUrl', data.BucketDomain)
    }
  },

  components: {
    CommonHeader
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0 0.49333333rem 0 0.52rem;
  font-size: 0.42666667rem; /* 原有 f-s(16) 换算值，可按原样保留 */
  .f-s(16);
  margin: 0 0.49333333rem 0 0.52rem;

  .logo {
    width: 250px;
    height: 100px;
    background: url(../assets/images/logo.png) no-repeat center center;
    background-size: 250px;
    margin: 0 auto;
    margin-top: 17px;
  }

  .have-border {
    border-bottom: 1px solid #4a90e2;
  }

  .input-wrap {
    .m-t(10);
    .title {
      .f-s(15);
      .m-t(16);
      .m-b(10);
      display: block;
      font-family: PingFangSC-Regular;
      font-weight: 500;
      color: rgba(20, 20, 20, 1);
      font-size: 0.42666667rem;
    }

    /deep/.cube-input {
      .w(335);
      /deep/.cube-input-field {
        padding: 0.266667rem 0;
        font-size: 0.3733333rem;
      }
    }

    /deep/.cube-input::after {
      border: 0;
      border-bottom: 1px solid #eee;
    }
  }

  /* 图形验证码区域样式 */
  .captcha-wrap {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 0.266667rem;

    .captcha-input-wrap {
      flex: 1;
      margin-top: 0;
      /deep/.cube-input {
        width: 100%;
      }
    }

    .captcha-image {
      width: 2.133333rem;
      height: 1.066667rem;
      margin-left: 0.266667rem;
      margin-bottom: 0.16rem;
      background-color: #f5f5f5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .captcha-loading {
        font-size: 0.32rem;
        color: #999;
      }

      .refresh-icon {
        position: absolute;
        right: 0.08rem;
        bottom: 0.08rem;
        font-size: 0.4rem;
        color: #ff8e1c;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 50%;
        width: 0.64rem;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        font-style: normal;
        font-weight: bold;
      }
    }
  }

  .identify_no_wrap {
    display: flex;
    align-items: flex-end;
    margin-top: 0.266667rem;

    /deep/.cube-input {
      .w(231);
    }

    .get_code_btn {
      .w(100);
      .h(40);
      .l-h(40);
      .f-s(13);
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      background: rgba(207, 207, 207, 1);
      border-radius: 2px;
    }

    .can_get_code {
      background: rgba(74, 144, 226, 1);
    }

    .cannot_get_code {
      background: rgba(207, 207, 207, 1);
    }
  }

  /*.xieYi {
    position: absolute;
    bottom: 0.4266667rem;
    left: 2.4266667rem;
    .agree {
      color: #666666;
      font-size: 0.32rem;
    }
    .agreeText {
      color: #141414;
      font-size: 0.32rem;
    }
  }*/

  .xieYi {
    margin-top: auto;
    margin-left: 1.926667rem;
    margin-bottom: 0.4266667rem;

    .agree {
      color: #666666;
      font-size: 0.32rem;
    }
    .agreeText {
      color: #141414;
      font-size: 0.32rem;
    }
  }

  .loginBtn {
    .h(46);
    .l-h(46);
    .w(337.5);
    .m-t(25);
    .f-s(16);
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background: rgba(193, 193, 193, 1);
    border-radius: 2px;
  }

  .canLogin {
    background: rgba(74, 144, 226, 1);
  }
}
</style>